module.exports = __webpack_public_path__ + "img/1550806304.973932fd.jpg";